module.exports = __webpack_public_path__ + "img/walter Raab_sanierung_start.72c56666.jpg";